import React,{useState} from "react"
import {whiteLink,whiteLinkBlueHover} from '../shared.module.scss'
import { Link } from "gatsby"

const DropdownSearchNav = ({menuClicked,useHoverState = false}) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const searchLinks = () => {
        let links = [
            {'Ann Arbor, MI': 'michigan:ann-arbor'},
            {'Ypsilanti, MI': 'michigan:ypsilanti'},
            {'Winter Park, FL': 'florida:winter-park'},
            {'Orlando, FL': 'florida:orlando'}
        ];
        return links.map((link, index) => {
            let cityName = Object.keys(link)[0];
            let [state, city] = link[cityName].split(':');
            //let url = `/search?city=${city}&state=${state}`;
            let url = `/apartments/${state}/${city}/`;
            //console.log(url);
            return <Link key={index} to={url} className={`dropdown-item topnav-search-${city}`}>{cityName}</Link>;
        });
    };
    
    const handleDropDownClick = (event) => {
        event.preventDefault();
        setDropdownOpen(!dropdownOpen);
    };
  return (
        <div className={dropdownOpen ? "dropdown is-active " : "dropdown"}>
                <a href="#" 
                className={
                    useHoverState ?
                    `${whiteLink} navbar-item dropdown-trigger ${whiteLinkBlueHover}`:
                    (menuClicked ? "navbar-item dropdown-trigger" : `${whiteLink} navbar-item dropdown-trigger`) 
                  }
                aria-haspopup="true" 
                aria-controls="dropdown-menu"
                id={useHoverState ? "apartment_link" : ''}
                onClick={handleDropDownClick}
                >
                    <span>Search Apartments</span>
                </a>
            <div className="dropdown-menu " id="dropdown-menu" role="menu">
                <div className="dropdown-content">
                    {searchLinks()}
                </div>
            </div>
        </div>
  );
};

export default DropdownSearchNav;